import React, { Component } from 'react';

import { connect } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { Col, Container, Row, Button } from 'react-bootstrap';

import AddUsers from '../../api/AddUser';
import AddUserEmployerType from '../../api/AddUserEmployerType';
import AddUserInsurerType from '../../api/AddUserInsurerType';
import BLOBList from '../../api/BLOBList';
import EmployerList from '../../api/EmployerList';
import LocationList from '../../api/LocationList';
import GetAdminConfiguration from '../../api/GetAdminConfig';
import RegistrationInfo from '../../api/RegistrationInfo';
import UserList from '../../api/UserList';
import UserListDetails from '../../api/UserListDetails';

import MemberCoverageSummary from '../../api/MemberCoverageSummary';
import MemberSummary from '../../api/MemberSummary';
import Dependent from '../../api/Dependent';
import ClaimStatusSummary from '../../api/ClaimStatusSummary';
import ClaimsList from '../../api/ClaimsList';
import RetryAPI from '../../api/RetryAPI';
import APIEndpoints from '../../api/APIEndpoints';
import SpendingAccountSummary from '../../api/SpendingAccountSummary';
import MyProfileDetails from '../../api/myProfileDetails';
import CookiesService from '../../shared/CookiesService';
import { ServerErrorSVG, CoverageSVG } from '../../img/GlobalSVG';
import AdminUserDetails from '../../api/AdminUserDetails';
import Breadcrumbs from '../../api/Breadcrumbs';
import MasterPermissions from '../../api/MasterPermissions';
import { resetBreadCrumb } from '../../../redux/admin/breadCrumbSlice';
import { resetReportsSlice } from 'src/redux/admin/reportsSlice';
import { logout } from '../../../redux/app/userSlice';
import { unSetKeys } from '../../../redux/app/keySlice';
import {
  setContentLoader,
  setIsTokenExpired,
  unSetLogin,
} from 'src/redux/app/appSlice';
import {
  unsetCoverageSummary,
  unsetAccumulatorSummary,
} from 'src/redux/member/memberSlice';
import GenericButton from '../../../Components/GenericButton/GenericButton';
import { resetNotificationResp } from 'src/redux/app/messageAndNotificationSlice';

//TODO: Convert to functional component and re-write clean CSS
class SessionLogout extends Component {
  constructor(props) {
    super(props);

    this.state = {
      logoutError: true,
      backtoLogin: false,
      serverError: false,
    };
  }

  async componentDidMount() {
    this.LogoutRequest();
    //this.props.logoutAction();
    //this.props.unSetKeys();
  }

  LogoutRequest = async () => {
    this.props.logoutAction();
    this.props.unSetKeys();
    //this.props.TimeOutAction( false );
    this.props.unSetLogin();
    this.props.unsetCoverageSummary();
    this.props.unsetAccumulatorSummary();
    this.props.resetNotificationResp();

    CookiesService.remove('loginToken');
    CookiesService.clear();
    localStorage.clear();
    console.log('Logout Successfull');
    this.props.TimeOutAction();
  };

  backtoLogin = () => {
    this.props.TimeOutAction();

    AddUsers.resetAddUers();
    AddUserEmployerType.resetAddUersInsurer();
    AddUserInsurerType.resetAddUersInsurer();
    BLOBList.resetBLOBList();
    EmployerList.resetEmployerList();
    GetAdminConfiguration.resetAdminConfigurationResp();
    LocationList.resetLocationList();
    RegistrationInfo.resetRegistrationInfo();
    UserList.resetUserList();
    UserListDetails.resetUserListDetails();

    MemberSummary.resetMemberSummary();
    MemberCoverageSummary.resetMemberCoverageSummary();
    Dependent.resetDependent();
    ClaimStatusSummary.resetClaimStatusSummary();
    RetryAPI.resetRetryAPI();
    ClaimsList.resetClaimsList();
    SpendingAccountSummary.resetSpendingSummary();
    MyProfileDetails.resetMyProfileDetails();
    CookiesService.clear();
    APIEndpoints.resetDomainResources();
    AdminUserDetails.resetUserListDetails();
    Breadcrumbs.resetUserListDetails();
    this.props.resetBreadCrumb();
    this.props.resetReportsSlice();
    MasterPermissions.resetPermissionFramework();

    this.setState({
      backtoLogin: true,
    });
  };

  render() {
    const { backtoLogin } = this.state;

    if (backtoLogin) return <Navigate to="/admin" push={true}></Navigate>;

    const element = (
      <Container className="mtop30 logout mx-0 px-0 m-auto">
        <div className="roller"></div>

        <Row className="h-100">
          <Col className="my-auto">
            <div id="tick-img">
              <ServerErrorSVG.SessionTimeoutSVG />
            </div>

            <Row className="w-50 mx-auto ">
              <Col>
                <h1>You have been logged out due to inactivity.</h1>

                <p>
                  You have been logged off after a period of inactivity that
                  exceeded the limit set by the site administrator.
                </p>

                <GenericButton
                  variant="primary"
                  onClick={this.backtoLogin}
                  className="login-button d-flex mx-auto text-center "
                >
                  LOGIN AGAIN
                </GenericButton>
              </Col>
            </Row>

            <Row className="w-50 mx-auto ">
              <Col className="didyouknow mb-0">
                <CoverageSVG.BulbSVG />

                <h2>Did you know?</h2>

                <p>
                  {' '}
                  If you are physically tired, the best thing to do is exercise
                  as it will give you more energy than sitting.
                </p>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    );

    return element;
  }
}

const mapStateToProps = (state) => {
  const { blockOfBusiness, location, employer } = state.breadCrumb;

  return {
    location,
    employer,
    blockOfBusiness,
    isLoggedIn: state.user.isLoggedIn,
    bearerToken: state.user.bearerToken,
    logoutApiConsumed: state.user.logoutApiConsumed,
  };
};

const mapDispatchToProps = (dispatch) => ({
  unSetKeys: () => dispatch(unSetKeys()),
  logoutAction: () => dispatch(logout()),
  TimeOutAction: () => dispatch(setIsTokenExpired()),
  resetBreadCrumb: () => dispatch(resetBreadCrumb()),
  resetReportsSlice: () => dispatch(resetReportsSlice()),
  setContentLoader: (num) => dispatch(setContentLoader(num)),
  unSetLogin: () => dispatch(unSetLogin()),
  unsetCoverageSummary: () => dispatch(unsetCoverageSummary()),
  unsetAccumulatorSummary: () => dispatch(unsetAccumulatorSummary()),
  resetNotificationResp: () => dispatch(resetNotificationResp()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SessionLogout);
